import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Wand2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { CourseMetaForm } from "@/components/record/CourseMetaForm";

export default function TextMode() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [subject, setSubject] = useState("Autre");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/courses/text", { title, subject, text });
      toast.success("C'est parti ! L'IA structure tes notes.");
      navigate(`/app/cours/${data.course_id}`);
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };

  return (
    <div data-testid="text-mode-page" className="max-w-3xl">
      <p className="eyebrow">Mode texte</p>
      <h1 className="mt-2 text-3xl font-extrabold tracking-tight sm:text-4xl">Coller mes notes</h1>
      <p className="mt-2 text-sm text-muted-foreground">Colle des notes prises à la main ou en vrac : l'IA les transforme en un cours propre et structuré, sans rien inventer.</p>
      <div className="mt-8"><CourseMetaForm title={title} setTitle={setTitle} subject={subject} setSubject={setSubject} disabled={busy} /></div>
      <Textarea data-testid="text-mode-textarea" value={text} onChange={(e) => setText(e.target.value)} disabled={busy}
        placeholder="Ex. : révolution 1789 — états généraux 5 mai — crise financière — 14 juillet prise bastille…"
        className="mt-5 min-h-[320px] rounded-2xl bg-card p-5 text-sm leading-relaxed" />
      <div className="mt-2 flex justify-between text-xs text-muted-foreground"><span>20 caractères minimum</span><span>{text.length.toLocaleString("fr-FR")} caractères</span></div>
      <button data-testid="text-mode-submit-button" disabled={text.trim().length < 20 || busy} onClick={submit}
        className="bg-brand mt-6 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-white disabled:opacity-50">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Wand2 className="h-4 w-4" />} Créer ma fiche structurée
      </button>
    </div>
  );
}
